// covered-by: qa/rickrubin/tests/specs/cca/knowledge.database.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import { knowledgeDatabaseSearchSchema } from "./search";
import KnowledgeDatabaseView from "./view";

import PendingComponent from "../../../../components/PendingComponent";
import {
  canAccessKnowledgeDatabase,
  requiresAuth,
} from "../../../../utils/auth";
import { authLayoutRoute } from "../../../auth-layout/route";
import { ticketsRoute } from "../../../tickets/route";
// TODO: move this to app-wide components
import ErrorComponent from "../../../tickets/routes/ticket/components/ErrorComponent";

export {
  KNOWLEDGE_DATABASE_DEFAULT_SEARCH,
  KNOWLEDGE_TABS,
  MEMORIES_TAB,
  RULE_STATUS_FILTERS,
  knowledgeDatabaseSearchSchema,
  type KnowledgeTab,
  type RuleStatusFilter,
} from "./search";

export const knowledgeDatabaseRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  validateSearch: (search: Record<string, unknown>) =>
    knowledgeDatabaseSearchSchema.parse(search),
  path: "settings/knowledge-database",
  beforeLoad() {
    requiresAuth();

    if (!canAccessKnowledgeDatabase()) {
      throw redirect({
        to: ticketsRoute.to,
      });
    }
  },
  component: KnowledgeDatabaseView,
  pendingComponent: PendingComponent,
  errorComponent: ErrorComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 1000,
  pendingMinMs: 500,
});
